import React, { lazy } from "react";

const LazyDataQuery = lazy(() => import("./DataCreate"));

const DataCreate = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyDataQuery {...props} />;

export default DataCreate;
